import React from "react";
import ApplicationsManagement from "./ApplicationsManagement";

const CandidateKanbanView: React.FC = () => {
  return <ApplicationsManagement viewMode="kanban" />;
};

export default CandidateKanbanView;
